import { toast } from "sonner";

// Auto-print a purchased label on the label printer: fetch the PDF through the
// CRM (same-origin blob), load it in a hidden iframe and open the print window.
// The operator picks the 4×6 label printer once; the browser remembers it.
export async function printLabelPdf(orderId, { fallbackUrl, label = "Label" } = {}) {
  const token = localStorage.getItem("lp_token");
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/orders/${orderId}/shopify-label/pdf`;
  let objUrl = null;
  try {
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error((await r.text()).slice(0, 200) || `HTTP ${r.status}`);
    objUrl = URL.createObjectURL(await r.blob());
  } catch (e) {
    if (fallbackUrl) {
      window.open(fallbackUrl, "_blank", "noopener");
      toast.warning(`${label} opened in a new tab — press Print there (${String(e).slice(0, 80)})`);
      return false;
    }
    toast.error(`${label} download failed: ${String(e).slice(0, 160)}`);
    return false;
  }
  const old = document.getElementById("lp-label-print-frame");
  if (old) old.remove();
  const frame = document.createElement("iframe");
  frame.id = "lp-label-print-frame";
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none";
  frame.src = objUrl;
  let printed = false;
  const tryPrint = () => {
    if (printed) return;
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
      printed = true;
      toast.success(`🖨 ${label} sent to the print window — choose the label printer`);
    } catch (_) {
      window.open(objUrl, "_blank", "noopener");
      toast.warning(`${label} opened in a new tab — press Print there`);
      printed = true;
    }
  };
  frame.onload = () => setTimeout(tryPrint, 400);
  document.body.appendChild(frame);
  setTimeout(tryPrint, 2500);
  return true;
}
